module.exports = __webpack_public_path__ + "static/media/lobby.65279105.jpg";